import React, { useState, useEffect } from "react";

import useFetchObjectByPost from "../../../../components/Hooks/useFetchObjectByPost";
import useFetchURL from "../../../../components/Hooks/useFetchURL";
import { sto } from "../../../../Context/InshData";
import { uri } from "../../../../help/Api";
import LoadingPage from "../../../../services/LoadingPage";

import VatReportsOne from "./VatReportsOne";
const defaultAutos = {
  Safes: [],
};


export default function VatReportsOneCon() {

  const tb = {
    wait: true,
    costcenter:true,
    AllBranches:true,

    stor: { ...sto,branch:sto.branchi},
    parms: { 
        branch:sto.branchi,
        iempid: sto.empi,
        db_name:sto?.db_name,
     },

  };

  const { object: AutoOptions, fetching: fetchAll } = useFetchObjectByPost(
    uri + "GetD",
    tb,
  );

  if (
    fetchAll ||
    !AutoOptions?.Branches
  )
    return <LoadingPage />;

  return (
  //  <InvoicesMain
    <VatReportsOne
      {...{
        AutoOptions,
      }}
    />
  );
}
